<template>
  <div class="sequenceFrom">
    <div class="customer-info">
      <div class="customer-info-item">
        <div class="customer-info-title">
          <!--图标-->
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icon-qiyexinxi"></use>
          </svg>
          <span>基础设置</span>
        </div>
        <div class="flex jend acenter">
          <!--展开-->
          <svg v-if="show" class="icon" aria-hidden="true" @click="changeShow">
            <use xlink:href="#icon-zhankaizhuangtai"></use>
          </svg>
          <!--收起-->
          <svg v-else class="icon" aria-hidden="true" @click="changeShow">
            <use xlink:href="#icon-shouqizhuangtai"></use>
          </svg>
        </div>
      </div>
      <div  class="editForm" v-show="show">
        <el-row :span="20" :offset="2">
          <el-form :ref="'form'+idx"  :model="wagesFrom" label-width="168px" :rules="rules">
            <el-col :span="12">
              <el-form-item label="工资单名称" prop="name">
                <el-input v-model="wagesFrom.name" placeholder="请输入内容" oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否显示空值" prop="ifNull">
                <el-select v-model="wagesFrom.ifNull" placeholder="是否显示空值">
                  <el-option label="是" value="10020001"></el-option>
                  <el-option label="否" value="10020002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否显示双语" prop="twoLanguage">
                <el-select v-model="wagesFrom.twoLanguage" placeholder="是否显示双语">
                  <el-option label="是" value="10020001"></el-option>
                  <el-option label="否" value="10020002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="orgTree">
              <el-form-item label="适用机构" prop="org" >
<!--                <treeselect ref="tree" v-model="wagesFrom.org"  :normalizer="normalizer" multiple="true" @select ="selectEvt" :options="options" />-->
                <el-select v-model="wagesFrom.org" multiple="true" placeholder="请选择机构">
                  <el-option
                    v-for="item in cusOrgList"
                    :key="item.id"
                    :label="item.orgName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect';
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import {getCusData,checkPaySettingAll} from  "@/api/wage/payGroup";
  import {getCompanyOrg} from "@/api/org/org";
  import store from '@/store';

  /*
    import {queryOrgTree} from "@/api/wage/payGroup";
  */
  import {queryOrgTree} from "@/api/sys/sys";
  export default {
    name: "paySequence",
    components:{Treeselect},
    props:{
      idx:{
        type:Number,
        default:0
      },
      wagesFrom:{
        type:Object,
        default:function(){
          return {
            name:"",
            empty:1,
            org:[],
            orgList:"",
            lang:1,
          }
        }
      },
    },
    data(){
      return{
        show:true,
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            { max:20, message: '不能超过20个字符', trigger: 'blur' },
          ],
          ifNull: [
            { required: true, message: '空值是否显示', trigger: 'change' }
          ],
          org: [
            { required: true, message: '请选择适用机构', trigger: 'blur' }
          ],
          twoLanguage: [
            { required: true, message: '请选择是否显示双语', trigger: 'change' }
          ],
        },
        cusId:"",
        options:[],
        cusOrgList: [],
      }
    },
    created(){
      this._getCusData();
      this._getCompanyOrg();
    },
    methods:{
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
      _getCusData(){
        getCusData().then((res) => {
          console.log('获取当前客户Id：', res.data.data.cusId);
          this.cusId= res.data.data.cusId;
          this._queryOrgTree(this.cusId);
        });
      },
      /*_queryOrgTree(){
        let obj = {};
        queryOrgTree(obj).then((res) => {
          this.options = res.data.data;
          console.log("机构下拉数据------",this.options);
        });
      },*/

      _queryOrgTree(cusId){
        queryOrgTree(cusId).then((res) => {
          console.log("数机构数据------",res.data.data);
          this.options = res.data.data;
          console.log('this.options------'+this.options)
        });
      },
      selectEvt(e){
        console.log(e.id);
      },
      changeShow(){
        this.show ?this.show = false:this.show = true
      },
      submitForm() {
        this.$refs['form'+this.idx].validate((valid) => {
          if (valid) {
            //校验是否信息重复
            let re = this.checkPaySettingAll();
            re.then(res=>{
              if(res){
                // 修改标题
                console.log("提交表单-----")
                //this.wagesFrom.name
                //this.wagesFrom.orgList=this.$refs.tree.getCheckedNodes();
                this.$emit("changeName",this.wagesFrom.name)
                return true;
              }else{
                this.$message.error("同一机构只能对应单一工资单！")
              }
            })
          } else {
            this.$message.error("请正确填写表单！")
            return false;
          }
        });
      },
      // 查询分公司
      _getCompanyOrg() {
          getCompanyOrg(store.getters.cusId).then((res) => {
              this.cusOrgList = res.data
            console.log("180适用机构数据----",this.cusOrgList);
          });
      },
      async checkPaySettingAll(){
        //后台查询是否重复
        return await checkPaySettingAll(this.wagesFrom).then(res=>{
          return res.data.data;
        })
      }
    }
  };
</script>

<style scoped>
  .editForm{
    width: calc(100% - 100px);
  }
  .sequences,.sequenceBox{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sequenceBox{
    width: 160px;
  }
  .sequence{
    width: 120px;
    height: 40px;
    color:#ffffff;
    font-size: 14px;
    line-height: 40px;
    text-align: center;
    background: #7ea7ca;
    border-radius: 4px;
    margin-right: 10px;
    /*cursor: pointer;*/
  }
  .sequenceArrow{
    color:#bbbbbb;
    font-size: 20px;
  }
  .sequenceBox.active .sequence{
    background: #008AFF;
    font-size: 16px;
  }
  .sequenceBox.pass .sequence{
    background: #008AFF;
  }
  .sequences .el-form >>> .el-form-item  .el-radio-group{
    margin-top: 0px;
    line-height: 30px;
  }

  .sequenceFrom  .orgTree >>>  .el-form-item__content{
    height: auto;
  }
  .sequenceFrom  .orgTree >>> .vue-treeselect__control{
    border: 1px solid #bbb;
  }
</style>
